import React from 'react';
import Button from '@material-ui/core/Button';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import 'assets/scss/control-layout.scss';
import checkIsMobile from 'utils/CheckIsMobile';

type ControlLayoutProps = {
	inputError: boolean;
	buttonBackName: string;
	buttonNextName: string;
	disableBackButton?: boolean;
	handleBackClick: () => void;
	handleNextClick: () => void;
};

export const ControlLayout = ({
	inputError,
	buttonBackName,
	buttonNextName,
	disableBackButton,
	handleBackClick,
	handleNextClick,
}: ControlLayoutProps) => {
	const size = checkIsMobile() ? 'medium' : 'large';
	return (
		<div className="ControlLayout">
			<div className="controls">
				{!disableBackButton ? (
					<Button
						variant="outlined"
						color="primary"
						disableElevation
						size={size}
						onClick={() => handleBackClick()}
					>
						{buttonBackName}
					</Button>
				) : null}

				<Button
					key={`${inputError}`}
					disabled={inputError}
					variant="contained"
					color="primary"
					size={size}
					// disableElevation
					endIcon={<ArrowForwardIcon />}
					onClick={() => handleNextClick()}
				>
					{buttonNextName}
				</Button>
			</div>
		</div>
	);
};
